<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :close-on-click-modal="false"
    width="670px"
    :before-close="handleClose"
    custom-class="login-dialog"
  >
    <i class="el-icon-close" @click="handleClose"></i>
    <h1 class="u-font-24 line-height-1 u-text-center">{{ i18n.title }}</h1>
    <div class="tabs-box">
      <span class="tabs-item" :class="{ active: form.userType === 'individual' }" @click="form.userType = 'individual'">{{ i18n.loginText1 }}</span>
      <span class="tabs-item" :class="{ active: form.userType === 'company' }" @click="form.userType = 'company'">{{ i18n.loginText2 }}</span>
    </div>
    <el-form :model="form" ref="form" :rules="formRules">
      <el-form-item prop="username">
        <el-input v-model="form.username" size="large" :placeholder="i18n.placeholder1" maxlength="40"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="form.password" size="large" :placeholder="i18n.placeholder2" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <div class="code-input-box">
          <el-input v-model="form.code" size="large" :placeholder="i18n.placeholder3" maxlength="6"></el-input>
          <div class="code-img" @click="getCodeImg">
            <img :src="imgUrl" class="img">
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="large" class="login-btn" :loading="requesting" @click="handleLogin">{{ i18n.loginButton }}</el-button>
      </el-form-item>
      <div class="u-text-right">
        <span>{{ i18n.noAccount }}</span>
        <span class="register-text" @click="handleToRegister">{{ i18n.register }}</span>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { getCaptcha } from '@/api/user'

export default {
  name: 'login-dialog',
  data () {
    return {
      visible: false,
      form: {
        userType: 'individual',
        username: 'linjianbao',
        password: '123456',
        code: '',
        key: '' // 图形验证码key值
      },
      formRules: {
        username: { required: true, message: '请输入账号', trigger: 'blur' },
        password: { required: true, message: '请输入密码', trigger: 'blur' },
        code: { required: true, message: '请输入图形验证码', trigger: 'blur' }
      },
      imgUrl: '', // 图形验证码图片地址
      requesting: false // 请求节流
    }
  },
  computed: {
    i18n () {
      return this.$t('login')
    }
  },
  methods: {
    open () {
      this.getCodeImg()
      this.visible = true
    },
    handleLogin () {
      if (this.requesting) return
      this.$refs.form.validate(val => {
        if (val) {
          this.requesting = true
          this.$store.dispatch('LoginByUsername', this.form).then(() => {
            this.requesting = false
            this.handleClose()
            this.$message.success('登录成功')
          }).catch(() => {
            this.requesting = false
            this.getCodeImg()
          })
        }
      })
    },
    getCodeImg () {
      getCaptcha().then(res => {
        this.form.key = res.data.key
        this.imgUrl = res.data.image
      })
    },
    handleToRegister () {
      this.handleClose()
      this.$router.push('/register')
    },
    handleClose () {
      this.visible = false
      this.$refs.form.clearValidate()
      this.form.userType = 'individual'
      this.form.username = ''
      this.form.password = ''
      this.form.code = ''
    }
  }
}
</script>

<style lang="scss">
.login-dialog {
  border-radius: 10px !important;
  .el-icon-close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #999;
    cursor: pointer;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    position: relative;
    height: 420px;
    padding: 40px 40px 20px 280px;
    background: url('../assets/img/login-bg.png') left top/240px 420px no-repeat;
  }
  .tabs-box {
    padding: 10px 70px 20px 70px;
    display: flex;
    justify-content: space-between;
  }
  .tabs-item {
    color: #666;
    border-bottom: 2px solid #fff;
    line-height: 34px;
    cursor: pointer;
    &:hover {
      color: $primary-color;
    }
    &.active {
      color: $primary-color;
      border-bottom: 2px solid $primary-color;
    }
  }
  .code-input-box {
    display: flex;
  }
  .code-img {
    width: 108px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #cecece;
    margin-left: 10px;
    cursor: pointer;
  }
  .img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
  .login-btn {
    width: 100%;
    border-radius: 20px;
  }
  .register-text {
    color: $primary-color;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
